export default "__VITE_ASSET__672ad632__"